<template>
  <div>
    <div class="sidebar-menu-page-small">
      <ul>
        <template v-for="item in navbars" >
          <li v-if="item.routerName === 'Analysis'"
            :key="item.routerName"
            :class="{'active': item.activeRouters.includes($route.name)}"
          >
            <a href="#analysis-submenu" data-toggle="collapse" class="item-menu" @click="toggleAnalysisSubmenu">
              <span class="nav-label">{{ item.label }}</span>
              <i class="fa" aria-hidden="true">{{ isOpenAnalysisSubmenu ? '-' : '+' }}</i>
            </a>
            <ul v-if="analysisSubmenu.length > 0"  id="analysis-submenu" class="nav-second-level collapse">
              <li
                v-for="sub in analysisSubmenu"
                :key="sub.seq"
                :class="{'active': $route.params.id && $route.params.id === sub.seq }"
              >
                <router-link :to="{name: item.routerName, params: {id: sub.seq}}" class="item-sub-menu" @click.native="$emit('handleTogglePageSmallMenu')">
                  <span class="nav-label">{{ sub.menuName }}</span>
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </router-link>
              </li>
            </ul>
          </li>

          <li v-else-if="item.routerName === 'Premium'"
            :key="item.routerName"
            class=""
            :class="{'active': item.activeRouters.includes($route.name)}"
          >
            <component
              :is="isBasicPlan ? 'a' : 'router-link'"
              :href="isBasicPlan ? 'https://salemon.my.canva.site/premium' : null"
              :to="!isBasicPlan ? {name: item.routerName} : null"
              :target="isBasicPlan ? '_blank' : null"
              class="item-menu"
              @click.native="isOpenAnalysisSubmenu = false; $emit('handleTogglePageSmallMenu', true)"
            >
              <span class="nav-label">{{ item.label }}</span>
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </component>
          </li>

          <li v-else
            :key="item.routerName"
            class=""
            :class="{'active': item.activeRouters.includes($route.name)}"
          >
            <router-link :to="{ name: item.routerName, params: item.params }" class="item-menu" @click.native="isOpenAnalysisSubmenu = false; $emit('handleTogglePageSmallMenu', true)">
              <span class="nav-label">{{ item.label }}</span>
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </router-link>
          </li>
        </template>
        <li>
          <a @click="$emit('doLogout')" class="item-menu">
            <span class="nav-label">ログアウト</span>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
      <hr>
      <p class="pd-l-15">version: {{ appVersion }}</p>
      <div class="pd-l-15 pd-t-20 other">
        <a class="text--underline" :href="downloadUrl" download target="_blank">
          <span>利用規約</span>
        </a>
        <br>
        <a class="text--underline" :href="downloadUrlV2" download target="_blank">
          <span>プライバシーポリシー</span>
        </a>
      </div>
      <div class="full-width mr-t-30">
        <button class="btn btn-primary full-width" @click="$emit('handleTogglePageSmallMenu')">閉じる</button>
      </div>
    </div>
    <div
      class="sidebar-overlay"
      @click="$emit('handleTogglePageSmallMenu')"
    ></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import navbars from '@/common/sidebar-menu'

export default {
  props: {
    downloadUrl: {
      type: String,
      default: ''
    },
    downloadUrlV2: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      navbars: navbars,
      isOpenAnalysisSubmenu: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      analysisSubmenu: 'getAnalysisMenu'
    }),
    appVersion () {
      return this.userInfo.version
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    }
  },
  methods: {
    toggleAnalysisSubmenu () {
      this.isOpenAnalysisSubmenu = !this.isOpenAnalysisSubmenu
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarMenuPageSmall.vue